import { SVGProps } from 'react'

export const Refuse = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36" {...props}>
    <rect width="36" height="36" fill="#05155E" fillOpacity="0.08" rx="18"></rect>
    <path
      fill="#05155E"
      d="M23.834 13.342l-1.175-1.175L18 16.825l-4.658-4.658-1.175 1.175L16.825 18l-4.658 4.659 1.175 1.175L18 19.175l4.659 4.659 1.175-1.175L19.175 18l4.659-4.658z"
    ></path>
  </svg>
)
